<template>
  <Article
    v-if="this.typeCheck === 'post' && responseData"
    :articleData="responseData"
  />

  <Review
    v-else-if="
      this.typeCheck === 'review' && !this.templateCheck && responseData
    "
    :reviewData="responseData"
  />

  <ReviewWithBlocks
    v-else-if="
      this.typeCheck === 'review' && this.templateCheck && responseData
    "
    :reviewNewData="responseData"
  />

  <PaymentOptions
    v-else-if="this.typeCheck === 'payment_options' && responseData"
    :paymentData="responseData"
  />

  <GameGuideHolder
    v-else-if="
      this.typeCheck === 'page' &&
      this.templateCheck === 'game-guide-holder' &&
      responseData
    "
    :gameguideholderData="responseData"
  />

  <AboutUs
    v-else-if="
      this.typeCheck === 'page' &&
      this.templateCheck === 'about-us' &&
      responseData
    "
    :aboutUsData="responseData"
  />

  <GameFree
    v-else-if="
      (this.typeCheck === 'game_free' || this.typeCheck === 'game_paid') &&
      responseData
    "
    :gamesData="responseData"
    :gameTemplate="this.typeCheck"
  />

  <DefaultPage
    v-else-if="
      this.typeCheck === 'page' &&
      (this.templateCheck === 'default-page' || this.templateCheck === '') &&
      responseData
    "
    :defaultPageData="responseData"
  />

  <News
    v-else-if="this.typeCheck === 'news' && responseData"
    :newsData="responseData"
  />

  <CalendarTemplate
    v-else-if="
      this.typeCheck === 'page' &&
      this.templateCheck === 'feast-group' &&
      responseData
    "
    :calendarData="responseData"
  />

  <MapTemplate
    v-else-if="
      this.typeCheck === 'page' &&
      this.templateCheck === 'usmap-page' &&
      responseData
    "
    :mapTemplateData="responseData"
  />

  <SoftwareProviders
    v-else-if="this.typeCheck === 'software_providers' && responseData"
    :softwareProviderData="responseData"
  />

  <Promotions
    v-else-if="
      (this.typeCheck === 'promotions' ||
        (this.typeCheck === 'page' &&
          this.templateCheck === 'promotions-landing')) &&
      responseData
    "
    :promotionData="responseData"
  />

  <HomeLayout2
    v-else-if="
      this.typeCheck === 'page' &&
      this.templateCheck === 'home-with-default' &&
      responseData
    "
    :homeLayout2Data="responseData"
  />

  <HomeLayout1
    v-else-if="
      this.typeCheck === 'page' && this.templateCheck === '' && responseData
    "
    :homeLayout1Data="responseData"
  />

  <NotFound v-else-if="this.typeCheck === 'error'" />
</template>

<script>
import Article from "@/pages/Article";
import Review from "@/pages/Review/Review";
import ReviewWithBlocks from "@/pages/Review/ReviewWithBlocks";
import News from "@/pages/News/News";
import Streams from "@/pages/Streams/Streams";
import GameGuideHolder from "@/pages/GameGuideHolder";
import GameFree from "@/pages/GameFree/GameFree";
import DefaultPage from "@/pages/DefaultPage";
import MapTemplate from "@/pages/MapTemplate";
import AboutUs from "@/pages/AboutUs";
import CalendarTemplate from "@/pages/CalendarTemplate";
import PaymentOptions from "@/pages/PaymentOptions/PaymentOptions";
import SoftwareProviders from "@/pages/SoftwareProviders/SoftwareProviders";
import Promotions from "@/pages/Promotions/Promotions";
import NotFound from "@/pages/404";
import HomeLayout1 from "@/pages/HomeLayout1";
import HomeLayout2 from "@/pages/HomeLayout2";

import { HttpService } from "@/api/Pages.api";

export default {
  name: "Preview",
  components: {
    Article,
    Review,
    ReviewWithBlocks,
    News,
    Streams,
    GameFree,
    PaymentOptions,
    GameGuideHolder,
    SoftwareProviders,
    Promotions,
    DefaultPage,
    MapTemplate,
    AboutUs,
    CalendarTemplate,
    NotFound,
    HomeLayout1,
    HomeLayout2,
  },
  data() {
    return {
      responseData: "",
      typeCheck: "",
      templateCheck: "",
    };
  },
  beforeCreate: function () {
    this.$root.loading = true;
  },
  created: function () {
    this.getPreviewData();
  },
  methods: {
    getPreviewData: function () {
      let caslist = {};

      const storedBreadcrumbData = localStorage.getItem("storedbreadcrumbData");

      if (
        storedBreadcrumbData &&
        storedBreadcrumbData !== 'undefined' &&
        JSON.parse(storedBreadcrumbData || "[]").length > 0
      ) {
        var that = this;
        let catList = JSON.parse(
          storedBreadcrumbData || "[]"
        ).filter((ele) => {
          return ele.slug === that.$route.params.postSlug;
        });

        if (catList.length > 0 && catList[0].hasOwnProperty("cat")) {
          caslist = {
            cat: catList[0].cat,
          };
        } else {
          if (
            localStorage.getItem("storedPageName") ===
            that.$route.params.postSlug
          )
            caslist = {
              cat: localStorage.getItem("storedData"),
            };
        }
      }
      HttpService.getPreview(
        this.$root.wp_country && this.$root.wp_country != ""
          ? this.$root.wp_country
          : this.$cookies.get("wp-country"),
        this.$root.wp_state && this.$root.wp_state != ""
          ? this.$root.wp_state
          : this.$cookies.get("wp-state"),
        this.$route.query.page_id
          ? this.$route.query.page_id
          : this.$route.query.p,
        this.$root.user_id,
        caslist
      )
        .then((res) => {
          const resData = res.data.data;
          if (resData.hasOwnProperty("code")) {
            this.typeCheck = "error";
          } else {
            this.typeCheck = resData.type;
            this.templateCheck = resData.template;
            if (this.typeCheck === "post") {
              this.responseData = resData;
            } else if (
              this.typeCheck === "page" &&
              this.templateCheck === "game-guide-holder"
            ) {
              this.responseData = resData;
            } else if (
              this.typeCheck === "page" &&
              this.templateCheck === "about-us"
            ) {
              this.responseData = resData;
            } else if (
              this.typeCheck === "game_free" ||
              this.typeCheck === "game_paid"
            ) {
              this.responseData = resData;
            } else if (
              this.typeCheck === "page" &&
              (this.templateCheck === "default-page" ||
                this.templateCheck === "")
            ) {
              this.responseData = resData;
            } else if (this.typeCheck === "news") {
              this.responseData = resData;
            } else if (this.typeCheck === "streams") {
              this.responseData = resData;
            } else if (this.typeCheck === "page" && this.templateCheck === "") {
              this.responseData = resData;
            } else if (
              this.typeCheck === "page" &&
              this.templateCheck === "usmap-page"
            ) {
              this.responseData = resData;
            } else if (
              this.typeCheck === "page" &&
              this.templateCheck === "feast-group"
            ) {
              this.responseData = resData;
            } else if (this.typeCheck === "review" && !this.templateCheck) {
              this.responseData = resData;
            } else if (this.typeCheck === "review" && this.templateCheck) {
              this.responseData = resData;
            } else if (this.typeCheck === "software_providers") {
              this.responseData = resData;
            } else if (
              this.typeCheck === "promotions" ||
              (this.typeCheck === "page" &&
                this.templateCheck === "promotions-landing")
            ) {
              this.responseData = resData;
            } else if (this.typeCheck === "payment_options") {
              this.responseData = resData;
            }
          }
          this.$root.loading = false;
          this.$root.body_loading_status = true;
        })
        .catch((err) => {
          this.typeCheck = "error";
          this.$root.loading = false;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Preview.vue